import { Link } from "react-router-dom";
import { ArrowRight, Recycle, Leaf, Sprout, TreePine } from "lucide-react";
import { Reveal } from "../store/Reveal";

const FIT_IMG = "https://static.wixstatic.com/media/d32254_cba0fcab2b8146d6bb76c786e488e2ca~mv2.jpg/v1/fill/w_900,h_500,al_c,q_85/d32254_cba0fcab2b8146d6bb76c786e488e2ca~mv2.jpg";

const ECO_BADGES = [
  { icon: Recycle, t: "100% riciclabile nella carta" },
  { icon: Leaf, t: "Compostabile e biodegradabile" },
  { icon: Sprout, t: "-80% plastica vs vaschette classiche" },
  { icon: TreePine, t: "Carta FSC® da foreste certificate" },
];

export const PackagingSection = () => (
  <section className="bg-[#F5EFE5]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20 lg:py-28 grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden border border-[#E7E0D8] shadow-[0_40px_80px_-40px_rgba(28,25,23,0.35)]">
            <img src="/packaging-3.jpg" alt="Packaging kraft sostenibile con vassoio in cellulosa" className="w-full h-full object-cover" />
          </div>
          <div className="absolute -bottom-5 -right-5 bg-white border border-[#E7E0D8] rounded-2xl px-5 py-3.5 shadow-xl">
            <p className="font-serif-display font-bold text-[#2E8A57] text-xl leading-none">100%</p>
            <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#78716C] mt-1">riciclabile</p>
          </div>
        </div>
      </Reveal>
      <div>
        <Reveal>
          <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#2E8A57] mb-3">Packaging sostenibile</p>
          <h2 className="font-serif-display font-bold text-2xl sm:text-3xl lg:text-4xl text-[#1C1917] tracking-tight">
            Una confezione che rispetta il pianeta.
          </h2>
          <p className="mt-5 text-[#44403C] leading-relaxed max-w-lg">
            Scatola in carta kraft naturale e vassoio in polpa di cellulosa: quasi zero plastica, tutto nella raccolta della carta. E il vassoio va direttamente in microonde o in forno.
          </p>
        </Reveal>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {ECO_BADGES.map((b, i) => (
            <Reveal key={b.t} delay={i * 0.08}>
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 shrink-0 rounded-full bg-[#2E8A57]/10 flex items-center justify-center">
                  <b.icon className="w-4 h-4 text-[#2E8A57]" />
                </div>
                <p className="text-sm font-medium text-[#1C1917]">{b.t}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <Link to="/packaging" data-testid="home-packaging-link" className="mt-9 inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm tracking-wide border border-[#1C1917] hover:bg-[#1C1917] hover:text-[#FDFBF7] transition-colors duration-300">
            Scopri tutti i vantaggi <ArrowRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export const GlutenFitBanner = () => (
  <section className="bg-[#243329] text-[#FDFBF7]">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20 lg:py-28 grid lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <p className="font-mono-accent text-xs uppercase tracking-[0.3em] text-[#7DC242] mb-4">Per gli sportivi</p>
        <h2 className="font-serif-display font-bold text-3xl sm:text-4xl tracking-tight">GLUTEN FIT</h2>
        <p className="mt-5 text-[#FDFBF7]/70 leading-relaxed max-w-md">
          Scopri il nostro menù GLUTEN FIT dedicato agli sportivi, che vogliono mangiar bene e tenersi in forma, ma senza glutine.
        </p>
        <Link to="/prodotti?cat=Gluten Fit" data-testid="glutenfit-banner-btn" className="mt-8 inline-flex items-center gap-2 px-8 py-4 rounded-full font-semibold text-sm bg-[#7DC242] text-[#243329] hover:bg-[#6BAB35] transition-colors">
          Scopri il menù <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="rounded-[2rem] overflow-hidden aspect-video border border-[#33463A]">
          <img src={FIT_IMG} alt="Gluten Fit" className="w-full h-full object-cover" />
        </div>
      </Reveal>
    </div>
  </section>
);
